import { inject, NewInstance } from 'aurelia-framework';
import { AuthService } from 'pages/login/service';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';

@inject(AuthService, NewInstance.of(ValidationController))
export class Login {
    constructor(authService, validationController) {
        this.user = {};

        this.authService = authService;
        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.validationController.addObject(this.user, 
            ValidationRules
            .ensure('email').required()
            .ensure('password').required()
            .rules);
    }

    async login() {
        await this.authService.login();
    }
}